// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__UvXmr","img":"style_img__2ouvf","active":"style_active__2gWoK"};